import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { checkEmailVerificationPublic, generateEmailVerificationPublic } from "./EmailVerificationSignupAPI"

const initialState = {
    loading: false,
    otpSent: false, // New state to track if OTP has been sent
    success: false, // This now strictly means OTP has been VERIFIED
    error: null,
}

// Thunk to generate email verification
export const generateEmailVerificationPublicAsync = createAsyncThunk(
    "generateEmailVerificationPublic",
    async (_, { rejectWithValue }) => {
        try {
            const data = await generateEmailVerificationPublic()
            return data
        } catch (error) {
            return rejectWithValue(error.message || "Failed to generate verification.")
        }
    },
)

// Thunk to check email verification code
export const checkEmailVerificationPublicAsync = createAsyncThunk(
    "checkEmailVerificationPublic",
    async (code, { rejectWithValue }) => {
        try {
            const data = await checkEmailVerificationPublic(code)
            return data
        } catch (error) {
            return rejectWithValue(error.message || "Verification failed.")
        }
    },
)

const checkEmailVerificationPublicSlice = createSlice({
    name: "CheckEmailVerification",
    initialState,
    reducers: {
        resetEmailVerificationState: (state) => {
            state.loading = false
            state.otpSent = false // Reset new state
            state.success = false
            state.error = null
        },
    },
    extraReducers: (builder) => {
        builder
            // generateEmailVerificationPublicAsync
            .addCase(generateEmailVerificationPublicAsync.pending, (state) => {
                state.loading = true
                state.otpSent = false // Ensure false when pending
                state.success = false
                state.error = null
            })
            .addCase(generateEmailVerificationPublicAsync.fulfilled, (state) => {
                state.loading = false
                state.otpSent = true // OTP successfully sent
                state.success = false // IMPORTANT: success is still false here
                state.error = null
            })
            .addCase(generateEmailVerificationPublicAsync.rejected, (state, action) => {
                state.loading = false
                state.otpSent = false
                state.success = false
                state.error = action.payload || "Failed to generate email verification."
            })
            // checkEmailVerificationPublicAsync
            .addCase(checkEmailVerificationPublicAsync.pending, (state) => {
                state.loading = true
                // otpSent remains true if it was set by generate action
                state.success = false
                state.error = null
            })
            .addCase(checkEmailVerificationPublicAsync.fulfilled, (state) => {
                state.loading = false
                state.otpSent = false // OTP no longer needed after verification
                state.success = true // OTP successfully VERIFIED
                state.error = null
            })
            .addCase(checkEmailVerificationPublicAsync.rejected, (state, action) => {
                state.loading = false
                // otpSent remains true if it was set by generate action, allowing re-entry of OTP
                state.success = false
                state.error = action.payload || "Verification failed."
            })
    },
})

export const { resetEmailVerificationState } = checkEmailVerificationPublicSlice.actions
export default checkEmailVerificationPublicSlice.reducer
